/**
 * Module dependencies.
 */

import { Transaction } from 'app/types/transaction';
import React from 'react';
import moment from 'moment';
import { formatCurrency } from 'app/core/utils/formatter';

/**
 * `Props` type.
 */

type Props = {
  item: Transaction;
};

/**
 * Export `TransactionItem` component.
 */

export function TransactionItem({ item }: Props): JSX.Element {
  const logo = item.account.integration?.logo;

  return (
    <div className={'grid'}>
      <div className={'flex flex-row items-center'}>
        {!!logo && <img className={'w-8 mr-4'} src={logo} />}

        <div className={'w-full flex flex-row justify-between'}>
          <div className={'text-sm'}>{item.account.name}</div>

          <div>{formatCurrency(item.amount)}</div>
        </div>
      </div>

      <div className={'mt-2 px-3 py-1.5 rounded-xl bg-[#ddd] flex flex-row justify-between'}>
        <div>{item.description ?? item.bank_description}</div>

        <div>{moment(item.date ?? item.bank_date).format('DD-MM-YYYY')}</div>
      </div>
    </div>
  );
}
